import { Injectable } from '@angular/core';
import { JSBridgeService } from '../common/jsbridge.service';
import { PlatformDetect } from '@libs/platform/platform-detect';

@Injectable({
  providedIn: 'root'
})
    
export class AccessibilityService {
  public toggleOn: boolean = false; // app accessibility toogle on
  

  constructor( 
    private jsBridgeSer: JSBridgeService,
    private platform: PlatformDetect
  ) {}

  async checkAccessibilityStatus() {
    const toggle = sessionStorage.getItem('accessibilityToggle');
    console.log('checkAccessibilityStatus toggle..',toggle);
    if (toggle) {
      this.toggleOn = toggle === 'true';
    } else { 
      /* only able to use accessinility fuction when currentVer(current app version) >= defaultVer(the default last support version)
        * result = 0 | 1 | -1 
        * 0: currentVer = defaultVer
        * 1: currentVer > defaultVer
        * -1: currentVer < defaultVer
      */
      const result = this.platform.getShdrAppVersion('accessibilityVer');
      if( result >= 0){
        const res = await this.jsBridgeSer.callJSBridge('accessibilityToggleStatus');
        if (res?.resultCode === 0) {
          console.log('accessibilityToggleStatus res..',res);
          this.toggleOn = res?.toggleOn;
          sessionStorage.setItem('accessibilityToggle', this.toggleOn.toString());
        }
      }
    }
  }

}
